export function isMobile() {
  return window.innerWidth < 720;
}
